import { CBreadcrumbItem } from './CBreadcrumbItem.js';
import { CBreadcrumb } from './CBreadcrumb.js';

const CBreadcrumbPlugin = {
    install: (app) => {
        app.component(CBreadcrumb.name, CBreadcrumb);
        app.component(CBreadcrumbItem.name, CBreadcrumbItem);
    },
};

export { CBreadcrumb, CBreadcrumbItem, CBreadcrumbPlugin };
//# sourceMappingURL=index.js.map
